export default __webpack_public_path__ + "static/media/Nice Vasconcelos_.7b07f546.png";